import { useEffect, useState } from "react";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import StyledReactMarkdown, {
  ScrollToSection,
} from "../utils/StyledComponents/StyledReactMarkdown";

const generateSlug = (text: string) => {
  if (!text || typeof text !== "string") return "";
  return text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};

const About = () => {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch("/md/about.md")
      .then((response) => response.text())
      .then((text) => setMarkdown(text))
      .catch((error) => console.error("Error loading markdown:", error));
  }, []);

  return (
    <>
      <ScrollToSection />
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "60vw" }}>
          <StyledReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
              h2: ({ node, ...props }) => {
                const firstChild = props.children;

                const slug =
                  Array.isArray(firstChild) && typeof firstChild[0] === "string"
                    ? generateSlug(firstChild[0])
                    : typeof firstChild === "string"
                      ? generateSlug(firstChild)
                      : "";

                return <h2 id={slug} {...props}></h2>;
              },
            }}
          >
            {markdown}
          </StyledReactMarkdown>
        </div>
      </div>
    </>
  );
};

export default About;
